import { useEffect, useState } from 'react';

const navLinks = [
  { label: '最新电影', href: '#movies' },
  { label: '热门剧集', href: '#series' },
  { label: '分类片库', href: '#category' },
  { label: '编辑精选', href: '#rank' },
  { label: '观影指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
            星辰影院
            <span className="hidden sm:inline text-xs font-normal text-foreground-500 ml-2">
              在线观影
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#category"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-fill"></i>
            开始观看
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300/60 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <nav className="max-w-7xl mx-auto px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-200/60 last:border-b-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#category"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              <i className="ri-play-fill"></i>
              开始观看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}